// filters types
export const FETCH_STATES = "FETCH_STATES";
export const SET_STATES = "SET_STATES";
export const SET_SELECTED_STATE = "SET_SELECTED_STATE";

export const SET_TERMS = "SET_TERMS";
export const SET_SELECTED_TERM = "SET_SELECTED_TERM";

// export const FETCH_UTILITIES = 'FETCH_UTILITIES';
// export const SET_UTILITIES = 'SET_UTILITIES';
export const SET_SELECTED_UTILITY = "SET_SELECTED_UTILITY";

// export const FETCH_LOAD_ZONES = 'FETCH_LOAD_ZONES';
// export const SET_LOAD_ZONES = 'SET_LOAD_ZONES';

export const SET_SELECTED_LOAD_ZONE = "SET_SELECTED_LOAD_ZONE";

export const SET_SELECTED_BILLING_METHOD = "SET_SELECTED_BILLING_METHOD";

export const FETCH_SUPPLIERS = "FETCH_SUPPLIERS";
export const SET_SUPPLIERS = "SET_SUPPLIERS";

// export const FETCH_RATE_CLASSES = 'FETCH_RATE_CLASSES';
// export const SET_RATE_CLASSES = 'SET_RATE_CLASSES';
export const SET_SELECTED_RATE_CLASS = "SET_SELECTED_RATE_CLASS";
export const SET_SELECTED_LOAD_PROFILE = "SET_SELECTED_LOAD_PROFILE";

export const FETCH_PRODUCT_TYPES = "FETCH_PRODUCT_TYPES";
export const SET_PRODUCT_TYPES = "SET_PRODUCT_TYPES";
export const SET_SELECTED_ProductType = "SET_SELECTED_ProductType";

export const FETCH_COST_COMPONENTS = "FETCH_COST_COMPONENTS";
export const SET_COST_COMPONENTS = "SET_COST_COMPONENTS";
export const SET_SELECTED_COST_COMPONENT = "SET_SELECTED_COST_COMPONENT";

export const SET_CUSTOMER_CLASS = "SET_CUSTOMER_CLASS";
export const SET_TAX_INCLUDED = "SET_TAX_INCLUDED";
export const SET_POR = "SET_POR";

export const SET_FROM_DATE = "SET_FROM_DATE";
export const SET_TO_DATE = "SET_TO_DATE";
export const SET_COMMODITY = "SET_COMMODITY";

// chart area types
export const SET_CHARTSDATA = "SET_CHARTSDATA";
export const SET_CHARTSDATA_LOADER = "SET_CHARTSDATA_LOADER";
export const FETCH_CHARTSDATA = "FETCH_CHARTSDATA";

export const FETCH_ERROR = "FETCH_ERROR";

// Markets types
export const FETCH_MARKETS = "FETCH_MARKETS";
export const SET_MARKETS = "SET_MARKETS";
export const SET_SELECTED_MARKET = "SET_SELECTED_MARKET";

// Effective date types
export const SET_EFFECTIVE_FROM_DATE = "SET_EFFECTIVE_FROM_DATE";
export const SET_EFFECTIVE_TO_DATE = "SET_EFFECTIVE_TO_DATE";
export const SET_START_FROM_DATE = "SET_START_FROM_DATE";
export const SET_START_TO_DATE = "SET_START_TO_DATE";
export const SET_NO_OF_MONTHS = "SET_NO_OF_MONTHS";

// numeric filters
export const SET_USAGE = "SET_USAGE";
export const SET_DEMAND = "SET_DEMAND";
export const SET_LOAD_FACTOR = "SET_LOAD_FACTOR";
export const SET_SELECTED_CLIENT_IDENTIFIER = "SET_SELECTED_CLIENT_IDENTIFIER";
